import Index from "../src/pages/Web__Index.gen"; // getServerSideProps as _getServerSideProps,

export default Index;

// export const getServerSideProps = _getServerSideProps;
